export default __webpack_public_path__ + "static/media/claim_dark.c41baa0b.png";